const route = () => '/pricelists';

export default route;


